import React from 'react'
import Icon from "../../assets/icons";

interface Statistics {
  totalTransactions: number;
  pendingTransactions: number;
  completedTransactions: number;
  pendingPayoutsp: number;
  failedTransactions: number;

}

interface TransactionCardsProps {
  statistics: Statistics;
  activeTab?: "payment" | "withdrawal";
}

const TransactionCard = ({ title, icon, value }: any) => {
  return (
    <section className="bg-white rounded-md border border-[#fff]">
      <div className="flex justify-between px-3 py-3">
        <Icon name={icon} />
      </div>
      <p className="font-bold text-[24px] pl-3">{value}</p>
      <span className="text-[12px] font-light pl-3">{title}</span>
    </section>
  )
}

export const TransactionCards = ({ statistics, activeTab }: TransactionCardsProps) => {
  return (
    <div className="grid lg:grid-cols-4 gap-8 mt-7 w-[95%] ">
      <TransactionCard
        title={activeTab === "payment" ? "Total payments" : "Total withdrawals"}
        icon="transact"
        value={statistics?.totalTransactions || 0}
      />
      <TransactionCard
        title={activeTab === "payment" ? "Pending payments" : "Pending withdrawals"}
        icon="transact"
        value={statistics?.pendingTransactions || 0}
      />
      <TransactionCard
        title={activeTab === "payment" ? "Completed payments" : "Completed withdrawals"}
        icon="transact"
        value={statistics?.completedTransactions || 0}
      />
      {/* <TransactionCard
        title="Pending payouts"
        icon="transact"
        value={statistics?.pendingPayoutsp || 0}
      /> */}
       <TransactionCard
        title={activeTab === "payment" ? "Failed payments" : "Failed withdrawals"}
        icon="transact"
        value={statistics?.failedTransactions || 0}
      />
    </div>
  )
}
